module.exports = __webpack_public_path__ + "static/20200804_154714-faf1b3bde0cb43f764d9fcaed81c9fd3.jpg";